import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import BookingManagementContainer from 'app/containers/CustomerCare/BookingManagement'
import { AppointmentProvider } from 'app/context/AppointmentContext'
import { PatientProvider } from 'app/context/PatientContext'
import { ItemCategoryProvider } from 'app/context/ItemCategoryContext'
import { ItemProvider } from 'app/context/ItemContext'

const BookingManagementCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.booking)}</PageTitle>
      <AppointmentProvider>
        <PatientProvider>
          <ItemCategoryProvider>
            <ItemProvider>
              <BookingManagementContainer />
            </ItemProvider>
          </ItemCategoryProvider>
        </PatientProvider>
      </AppointmentProvider>
    </>
  )
}
const BookingManagementPage = memo(BookingManagementCpn, isEqual)

export default BookingManagementPage
